import { jsonp, get } from '../../test/unit/request';

export async function get_config_info(contentId){
  const res = await get('https://query.aliyun.com/rest/'+contentId,{});
  return res;
}

export async function open_reg() {
  const res = await jsonp('//page.aliyun.com/ambassador/groupBuy/create', 
    {
      'buy': true,
      templateId: window.__config_data_base.templateId,
      umidToken: window.umidToken,
      collina: window.getUA && window.getUA()
    });
  return res;
}

export async function fetchError_text() {
  const res = await get('https://query.aliyun.com/rest/aliyun_index.cloudpartner.group.base_error_code', 
    {
       
    });
  return res;
}

/**校验是否有购买资格 */
export async function validateQualification(buyCode) {
  const res = await jsonp('//page.aliyun.com/ambassador/groupBuy/possible', 
    {
      'buy': true,
      'buyCode': buyCode,
      umidToken: window.umidToken,
      collina: window.getUA && window.getUA()
    });
  return res;
}
  
export async function fetch_group(groupId) { // 获取已支付人数
  const res = await jsonp('//page.aliyun.com/ambassador/groupBuy/query', 
    {
      'buyCode': groupId //'o7lVUftIT7'
    });
  return res;
}
  


// WEBPACK FOOTER //
// ./src/assets/service.js